import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=836fe318"
import script from "./TableFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFooter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports